import React, { useState } from 'react';
import { OsbContentResponse } from '../../../../../models/osb-model/osb-content-details';
import OsbUtilService from '../../../../../services/osb-service/osb-util-service/osb-util-service';
import {
    BOOKING_CONFIRMATION_KEYS,
    BOOKING_SUMMARY_CONTAINER_KEYS,
    SERVICE_FLOW,
    SERVICES_STEP_KEYS,
} from '../../osb-constant';
import './light-booking-details-lincoln.scss';
import {
    useOSBStep,
    useLightDeliveryOptionServiceStep,
    useVehicleStep,
    useServiceStep,
    useDealerStep,
    useViewport,
    useServiceLocationStep,
    useOsbImageUpload,
    useCalendarStep,
} from '../../../../../hooks/owners-osb';
import { OSBVideoLink } from '../../common/osb-video-link/osb-video-link';
import { OSBVideoImageOverlay } from '../../common/osb-overlay/osb-video-image-overlay';
import { OSBBrightcoveVideoPlayer } from '../../common/osb-brightcove-video-player/osb-brightcove-video-player';
import {
    isConvenienceOptionIncluded,
    showServiceLocationDetails,
} from '../../osb-utils';
import { FormatAddress } from '../../common/osb-common-components/osb-common-components';
import { useOSBContentFragment } from '../../../../../hooks/owners-osb/aem-content-util/use-osb-content-fragment';
// properties
export interface Props {
    isLoading: boolean;
    isDealerDeepLinked: boolean; // NOSONAR
    dealerName: string;
    dealerAddress: string; // NOSONAR
    dealerPostalCode: string; // NOSONAR
    selectedDate: string;
    selectedTime: string;
    bookingNumber: string;
    accessCode: string;
    bookingConfirmationStepContent?: OsbContentResponse;
    handlePrint?: () => void;
}

export const LightBookingDetails = (props: Props) => {
    const { osbServiceLocationDetail } = useServiceLocationStep();
    const { isMobileView } = useViewport();
    const { osbStep } = useOSBStep();
    const { osbLightDeliveryServiceStep } = useLightDeliveryOptionServiceStep();
    const { osbVehicleStep } = useVehicleStep();
    const { osbServiceStep } = useServiceStep();
    const { osbDealerStep } = useDealerStep();
    const { osbImageUploadStep } = useOsbImageUpload();
    const { osbCalendarStep } = useCalendarStep();
    const reviewBookingContent = useOSBContentFragment(
        'common/owners-osb',
        'osb-review-booking'
    );
    const [isVideoOverlayOpened, setIsVideoOverlayOpened] = useState(false);
    const [brightCoveAccountId, setBrightCoveAccountId] = useState('');
    const [brightCoveVideoId, setBrightCoveVideoId] = useState('');
    const [brightCovePlayerId, setBrightCovePlayerId] = useState('');
    const [brightCoveVideoName, setBrightCoveVideoName] = useState('');
    if (!reviewBookingContent) {
        return null;
    }
    const vehicleDetails = osbVehicleStep.vehicleDetails;
    const vehicleName =
        vehicleDetails?.modelName +
        ' ' +
        vehicleDetails?.buildDate.substring(0, 4);
    const selectedServicesList = osbServiceStep.selectedServices || [];
    const firstSelectedService = selectedServicesList[0];

    const selectedOtherOptionsServices =
        (osbServiceStep.isMobileServiceSelected
            ? osbServiceLocationDetail.selectedOtherOptions
            : osbLightDeliveryServiceStep.selectedServices) || [];

    const getServiceKey = (
        service: any,
        index: number,
        prefix: string,
        suffix?: string | number
    ): string => {
        const baseKey =
            service?.id ||
            service?.serviceUniqueId ||
            `${prefix}-${service?.serviceCode || service?.serviceId || index}`;

        return suffix === undefined ? baseKey : `${baseKey}-${suffix}`;
    };

    const showVideoOverlay = (
        accountId = '',
        videoId = '',
        playerId = '',
        videoName = ''
    ) => {
        if (accountId && videoId && playerId) {
            setIsVideoOverlayOpened(true);
            setBrightCoveAccountId(accountId);
            setBrightCoveVideoId(videoId);
            setBrightCovePlayerId(playerId);
            setBrightCoveVideoName(videoName);
        }
    };

    const hideVideoOverlay = () => {
        setIsVideoOverlayOpened(false);
        setBrightCoveAccountId('');
        setBrightCoveVideoId('');
        setBrightCovePlayerId('');
        setBrightCoveVideoName('');
    };

    return (
        <div className="osb-light-booking-details-section">
            <div className="osb-light-booking-details-header">
                {!props.isLoading
                    ? props.bookingConfirmationStepContent?.elements.find(
                          key =>
                              key.name ===
                              BOOKING_CONFIRMATION_KEYS.BOOKING_DETAIL_TITLE
                      )?.value + ''.toString()
                    : ''}
            </div>
            <div className="osb-light-booking-details-container">
                {!isMobileView && <div className="hr-line"></div>}
                {!OsbUtilService.isEmptyObject(vehicleDetails) &&
                    vehicleDetails?.modelName !== '' &&
                    vehicleDetails?.modelName.toUpperCase() !==
                        osbVehicleStep.defaultModelName?.toUpperCase() && (
                        <div className="vehicle-section">
                            <div className="vehicle-title">
                                {reviewBookingContent.Vehicle_Label}
                            </div>
                            <div className="vehicle-name">{vehicleName}</div>

                            <div className="hr-line-style"></div>
                        </div>
                    )}
                {selectedServicesList.length === 0 &&
                    osbServiceStep.isMobileServiceSelected && (
                        <div className="service-section">
                            <div className="service-title">
                                {
                                    reviewBookingContent[
                                        BOOKING_SUMMARY_CONTAINER_KEYS
                                            .SERVICES_LABEL
                                    ]
                                }
                            </div>
                            <div className="service-sub-title">
                                {
                                    reviewBookingContent[
                                        BOOKING_SUMMARY_CONTAINER_KEYS
                                            .MOBILE_SERVICE_TITLE
                                    ]
                                }
                            </div>
                            <div className="hr-line-style"></div>
                        </div>
                    )}
                {selectedServicesList.length > 0 && (
                    <div className="service-section">
                        <div className="service-title">
                            {
                                reviewBookingContent[
                                    BOOKING_SUMMARY_CONTAINER_KEYS
                                        .SERVICES_LABEL
                                ]
                            }
                        </div>
                        <div>
                            {firstSelectedService?.serviceOption ===
                            SERVICE_FLOW.CARD_TYPE_GENERAL_APPOINTMENT_SERVICE ? (
                                <>
                                    <div className="service-sub-title">
                                        {
                                            reviewBookingContent[
                                                BOOKING_SUMMARY_CONTAINER_KEYS
                                                    .GENERAL_APPOINTMENT_SERVICE_LABEL
                                            ]
                                        }
                                    </div>
                                    <OSBVideoLink
                                        selectedService={firstSelectedService}
                                        showVideoOverlay={showVideoOverlay}
                                    />
                                </>
                            ) : (
                                <div className="service-sub-title">
                                    {osbServiceStep.isMobileServiceSelected
                                        ? reviewBookingContent[
                                              BOOKING_SUMMARY_CONTAINER_KEYS
                                                  .MOBILE_SERVICE_TITLE
                                          ]
                                        : reviewBookingContent[
                                              BOOKING_SUMMARY_CONTAINER_KEYS
                                                  .SPECIFIC_SERVICES_LABEL
                                          ]}
                                </div>
                            )}
                        </div>
                        <div>
                            <div className="services-list">
                                {firstSelectedService?.serviceOption !==
                                    SERVICE_FLOW.CARD_TYPE_GENERAL_APPOINTMENT_SERVICE &&
                                    selectedServicesList.map(
                                        (
                                            selectedService: any,
                                            selectedServiceIndex: number
                                        ) => (
                                            <div
                                                key={getServiceKey(
                                                    selectedService,
                                                    selectedServiceIndex,
                                                    'selected-service'
                                                )}
                                            >
                                                <div className="single-service">
                                                    <div className="service-name">
                                                        {
                                                            selectedService.serviceName
                                                        }
                                                        {selectedService.subType &&
                                                            selectedService.subType ===
                                                                SERVICE_FLOW.SERVICE_SUBTYPE_RECALL && (
                                                                <div className="light-recall-service-desc">
                                                                    {osbServiceStep.recallServiceDescription.map(
                                                                        (
                                                                            desc,
                                                                            descIndex
                                                                        ) => (
                                                                            <div
                                                                                key={getServiceKey(
                                                                                    selectedService,
                                                                                    selectedServiceIndex,
                                                                                    'recall-desc',
                                                                                    descIndex
                                                                                )}
                                                                            >
                                                                                {
                                                                                    desc
                                                                                }
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            )}
                                                        {selectedService.subType &&
                                                            selectedService.subType ===
                                                                SERVICE_FLOW.SERVICE_SUBTYPE_VHA && (
                                                                <div className="light-recall-service-desc">
                                                                    {osbServiceStep.vhaServiceDescription?.map(
                                                                        (
                                                                            desc,
                                                                            descIndex
                                                                        ) => (
                                                                            <div
                                                                                key={getServiceKey(
                                                                                    selectedService,
                                                                                    selectedServiceIndex,
                                                                                    'vha-desc',
                                                                                    descIndex
                                                                                )}
                                                                            >
                                                                                {
                                                                                    desc
                                                                                }
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            )}
                                                        {selectedService.subType &&
                                                            selectedService.subType ===
                                                                SERVICE_FLOW.SERVICE_SUBTYPE_OIL && (
                                                                <div className="light-recall-service-desc">
                                                                    <div>
                                                                        {
                                                                            osbServiceStep.oilLifeServiceReminderDescription
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )}
                                                        {selectedService.subType &&
                                                            selectedService.subType ===
                                                                SERVICE_FLOW.OTHER_CUSTOMSERVICE && (
                                                                <div className="light-recall-service-desc">
                                                                    -{' '}
                                                                    {
                                                                        osbServiceStep.otherServiceDesc
                                                                    }
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                                <OSBVideoLink
                                                    selectedService={
                                                        selectedService
                                                    }
                                                    showVideoOverlay={
                                                        showVideoOverlay
                                                    }
                                                />
                                            </div>
                                        )
                                    )}
                            </div>
                        </div>
                        {osbImageUploadStep.uploadedImage &&
                            osbImageUploadStep.uploadedImage?.length > 0 &&
                            reviewBookingContent[
                                SERVICES_STEP_KEYS.IMAGE_UPLOADED_LABEL
                            ] && (
                                <div className="image-upload-count">
                                    {`${
                                        reviewBookingContent[
                                            SERVICES_STEP_KEYS
                                                .IMAGE_UPLOADED_LABEL
                                        ]
                                    } (${
                                        osbImageUploadStep.uploadedImage?.length
                                    })`}
                                </div>
                            )}
                        <div className="hr-line-style"></div>
                    </div>
                )}
                {selectedOtherOptionsServices.length > 0 && (
                    <div className="service-section">
                        <div className="service-title">
                            {
                                reviewBookingContent[
                                    BOOKING_SUMMARY_CONTAINER_KEYS
                                        .DELIVERY_SERVICES_LABEL
                                ]
                            }
                        </div>
                        <div>
                            <div className="services-list">
                                {selectedOtherOptionsServices.map(
                                    (
                                        selectedOptionalService: any,
                                        selectedOptionalServiceIndex: number
                                    ) => (
                                        <div
                                            key={getServiceKey(
                                                selectedOptionalService,
                                                selectedOptionalServiceIndex,
                                                'selected-optional-service'
                                            )}
                                        >
                                            <div className="single-service">
                                                <div className="service-name">
                                                    {
                                                        selectedOptionalService.serviceName
                                                    }
                                                    {selectedOptionalService.convenienceOptionTypes &&
                                                        isConvenienceOptionIncluded(
                                                            selectedOptionalService.convenienceOptionTypes,
                                                            SERVICE_FLOW.PICKUP_AND_DELIVERY_CONVENIENCE_OPTION_TYPE
                                                        ) && (
                                                            <div className="pick-up-details">
                                                                <div className="selected-pickup-date">
                                                                    {osbCalendarStep
                                                                        .selectedPickupDate
                                                                        .length >
                                                                        0 &&
                                                                        OsbUtilService.constructDisplayDate(
                                                                            osbCalendarStep.selectedPickupDate,
                                                                            reviewBookingContent[
                                                                                BOOKING_SUMMARY_CONTAINER_KEYS
                                                                                    .DATE_FORMAT_SUMMARY
                                                                            ]?.toString(),
                                                                            OsbUtilService.getAppConfiguration()
                                                                                .languageRegionCode
                                                                        )}
                                                                </div>
                                                                <div className="selected-pickup-time">
                                                                    {osbCalendarStep
                                                                        .selectedPickupTime
                                                                        .length >
                                                                        0 &&
                                                                        OsbUtilService.getTimeBasedOnAuthoring(
                                                                            osbCalendarStep.selectedPickupTime,
                                                                            osbStep.twelveHrsTimeFormat,
                                                                            osbStep.amTimeLabel,
                                                                            osbStep.pmTimeLabel,
                                                                            osbStep.timeSuffixLabel
                                                                        )}
                                                                </div>
                                                                <div className="customer-address">
                                                                    <FormatAddress
                                                                        addressData={
                                                                            osbServiceLocationDetail
                                                                        }
                                                                        addressOrder={
                                                                            osbStep.dealerAddressOrder
                                                                        }
                                                                        isDisplaySingleRow={
                                                                            false
                                                                        }
                                                                    />
                                                                </div>
                                                                {osbServiceLocationDetail.comment.trim()
                                                                    .length >
                                                                    0 && (
                                                                    <div className="sl-comments">
                                                                        {`"${osbServiceLocationDetail.comment}"`}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                            <OSBVideoLink
                                                selectedService={
                                                    selectedOptionalService
                                                }
                                                showVideoOverlay={
                                                    showVideoOverlay
                                                }
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                        <div className="hr-line-style"></div>
                    </div>
                )}
                {isVideoOverlayOpened && (
                    <OSBVideoImageOverlay
                        isOpen={isVideoOverlayOpened}
                        backButtonText={osbStep.videoPlayerBackButtonLabel}
                        hideVideoOverlay={hideVideoOverlay}
                        isVideo={true}
                    >
                        <OSBBrightcoveVideoPlayer
                            accountId={brightCoveAccountId}
                            videoId={brightCoveVideoId}
                            playerId={brightCovePlayerId}
                            videoName={brightCoveVideoName}
                        />
                    </OSBVideoImageOverlay>
                )}
                <div className="when-section">
                    <div className="when-title">
                        {!props.isLoading
                            ? props.bookingConfirmationStepContent?.elements.find(
                                  key =>
                                      key.name ===
                                      BOOKING_CONFIRMATION_KEYS.WHEN_LABEL
                              )?.value + ''.toString()
                            : ''}
                    </div>
                    <div className="date-time">
                        {OsbUtilService.constructDisplayDate(
                            props.selectedDate,
                            reviewBookingContent[
                                BOOKING_SUMMARY_CONTAINER_KEYS
                                    .DATE_FORMAT_SUMMARY
                            ]?.toString(),
                            OsbUtilService.getAppConfiguration()
                                .languageRegionCode
                        )}
                        <br></br>
                        {osbCalendarStep.selectedTime && (
                            <div>
                                {
                                    reviewBookingContent[
                                        BOOKING_SUMMARY_CONTAINER_KEYS
                                            .TIME_AT_LABEL
                                    ]
                                }{' '}
                                {OsbUtilService.getTimeBasedOnAuthoring(
                                    props.selectedTime,
                                    osbStep.twelveHrsTimeFormat,
                                    osbStep.amTimeLabel,
                                    osbStep.pmTimeLabel,
                                    osbStep.timeSuffixLabel
                                )}
                            </div>
                        )}

                        {osbCalendarStep.selectedTimeRange && (
                            <div>
                                {reviewBookingContent.Time_Between_Label}{' '}
                                {osbCalendarStep.selectedTimeRange}
                            </div>
                        )}
                    </div>
                    <div className="hr-line-style"></div>
                </div>
                {showServiceLocationDetails(
                    osbServiceStep.isMobileServiceSelected,
                    osbServiceLocationDetail
                ) && (
                    <div className="service-location-container">
                        <div className="service-location-title">
                            {
                                reviewBookingContent[
                                    BOOKING_SUMMARY_CONTAINER_KEYS
                                        .SERVICE_LOCATION_TITLE
                                ]
                            }
                        </div>
                        <div className="service-location-details">
                            <div className="customer-address">
                                <FormatAddress
                                    addressData={osbServiceLocationDetail}
                                    addressOrder={osbStep.dealerAddressOrder}
                                    isDisplaySingleRow={false}
                                />
                            </div>
                            <div className="parking-type">
                                {osbServiceLocationDetail.parkingType}
                            </div>
                            {osbServiceLocationDetail.comment.trim().length >
                                0 && (
                                <div className="sl-comments">
                                    {`"${osbServiceLocationDetail.comment}"`}
                                </div>
                            )}
                        </div>
                        <div className="hr-line-style"></div>
                    </div>
                )}
                <div className="where-section">
                    <div className="where-title">
                        {!props.isLoading
                            ? props.bookingConfirmationStepContent?.elements.find(
                                  key =>
                                      key.name ===
                                      BOOKING_CONFIRMATION_KEYS.WHERE_LABEL
                              )?.value + ''.toString()
                            : ''}
                    </div>
                    <div className="dealer-name">{props.dealerName}</div>
                    <div className="dealer-address">
                        <FormatAddress
                            addressData={osbDealerStep.selectedDealerProfile}
                            addressOrder={osbStep.dealerAddressOrder}
                            isDisplaySingleRow={false}
                        />
                    </div>

                    <div className="hr-line-style"></div>
                </div>

                <div className="booking-number-section">
                    <div className="booking-number-title">
                        {!props.isLoading
                            ? props.bookingConfirmationStepContent?.elements.find(
                                  key =>
                                      key.name ===
                                      BOOKING_CONFIRMATION_KEYS.BOOKING_NUMBER_LABEL
                              )?.value + ''.toString()
                            : ''}
                    </div>
                    <div className="booking-number">{props.bookingNumber}</div>
                    <div className="hr-line-style"></div>
                </div>
                <div className="access-code-section">
                    <div className="access-code-title">
                        {!props.isLoading
                            ? props.bookingConfirmationStepContent?.elements.find(
                                  key =>
                                      key.name ===
                                      BOOKING_CONFIRMATION_KEYS.ACCESS_CODE_LABEL
                              )?.value + ''.toString()
                            : ''}
                    </div>
                    <div className="access-code">{props.accessCode}</div>
                    {isMobileView && <div className="hr-line-style"></div>}
                </div>
                <div className="links-section">
                    <div className="print-booking-details">
                        {/* eslint-disable-next-line */}
                        <a className="link-style" onClick={props.handlePrint}>
                            {!props.isLoading
                                ? props.bookingConfirmationStepContent?.elements.find(
                                      key =>
                                          key.name ===
                                          BOOKING_CONFIRMATION_KEYS.PRINT_BOOKING_LINK
                                  )?.value + ''.toString()
                                : ''}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
